//TODO VALIDAR ISSO

import {
  ArrowBack as ArrowBackIcon,
  CheckCircle as CheckCircleIcon,
  FileDownload as FileDownloadIcon,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { QRCodeSVG } from "qrcode.react";
import empreendimentoService from "../services/empreendimento";
import licencaEmitidaService from "../services/licencaEmitida";
import licencasService from "../services/licencas";
import usuarioService from "../services/usuario";
import pdfLayoutService from "../services/pdfLayout";
import {
  formatCEP,
  formatCpfCnpj,
  formatDate,
  formatDateToShow,
  formatarEnderecoLicenca,
  parseDateWithoutTimezone,
} from "../utils/formatters";
import { UNIDADE_MEDIDA_AREA_OPTIONS } from "../utils/constants";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";
import {
  html2canvasForPdf,
  PDF_DOCUMENT_WIDTH_PX,
  PDF_PAGE_HEIGHT_MM,
  PDF_PAGE_WIDTH_MM,
  PDF_SIG_BOX_H_MM,
  PDF_SIG_BOX_W_MM,
  PDF_SIG_BOX_X_MM,
  PDF_SIG_BOX_Y_TOP_MM,
  PDF_SIG_DATE_W_MM,
  PDF_SIG_DATE_X_MM,
  PDF_SIG_LABEL_HEIGHT_MM,
  addSlicedContentImage,
  canvasHeightInMm,
  canvasToJpegDataUrl,
  getContentPaging,
  withFixedPdfCaptureWidth,
} from "../utils/pagedHtmlPdf";
import authService from "../services/auth";
import licencaHeaderImg from "../assets/images/licenca-header.png";
import licencaFooterImg from "../assets/images/licenca-footer.png";
import NumeroProcessoField, {
  ehNumeroInformadoValido,
  montarNumeroProcessoPreview,
} from "../components/NumeroProcessoField";
import CharCounter from "../components/CharCounter";
import {
  isPessoaJuridica,
  isRepresentadoPessoaJuridica,
  montarEnderecoDoSnapshotRepresentado,
  obterNomeExibicaoRepresentado,
  obterNomeExibicaoUsuario,
  obterRazaoSocialRepresentado,
  obterRazaoSocialUsuario,
  obterRotuloNomeRepresentado,
  obterRotuloNomeSolicitante,
} from "../utils/obterNomeExibicaoUsuario";

const NUMERO_DA_LICENCA_MAX = 100;

const temaDocumentoLicenca = createTheme({
  palette: {
    mode: "light",
    text: {
      primary: "#000000",
      secondary: "#333333",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
  },
  typography: {
    allVariants: {
      color: "#000000",
    },
  },
});

const estilosDocumentoLicenca = {
  backgroundColor: "#ffffff",
  color: "#000000",
  p: 3,
  fontSize: "11px",
  lineHeight: 1.8,
  fontFamily: "Arial, sans-serif",
  borderTop: "none",
  borderBottom: "none",
  "& .MuiTypography-root": {
    color: "#000000",
  },
  "& strong": {
    color: "#000000",
  },
};

function formatarDataValidadeLicenca(valor) {
  if (!valor) return null;
  const apenasData = String(valor).slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(apenasData)) {
    return formatDate(parseDateWithoutTimezone(apenasData));
  }
  return formatDate(valor);
}

function EmitirLicenca({ modoRegeneracao = false }) {
  const { id } = useParams();
  const navigate = useNavigate();
  useTheme();
  const previewRef = useRef(null);
  const headerRef = useRef(null);
  const footerRef = useRef(null);
  const contentRef = useRef(null);
  const [solicitacao, setSolicitacao] = useState(null);
  const [solicitante, setSolicitante] = useState(null);
  const [empreendimento, setEmpreendimento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [emitindo, setEmitindo] = useState(false);
  const [confirmacaoRegeneracaoAberta, setConfirmacaoRegeneracaoAberta] =
    useState(false);
  const [sucessoEmissao, setSucessoEmissao] = useState(false);
  const [licencaEmitida, setLicencaEmitida] = useState(null);
  const [usuarioAtual, setUsuarioAtual] = useState(null);
  const [observacoesEditadas, setObservacoesEditadas] = useState("");
  const [condicionantesGerais, setCondicionantesGerais] = useState("");
  const [condicionantesComPrazo, setCondicionantesComPrazo] = useState("");
  const [condicionantesEspecificas, setCondicionantesEspecificas] = useState("");
  const [numeroInformado, setNumeroInformado] = useState("");
  const [numeroDaLicenca, setNumeroDaLicenca] = useState("");
  const [mostrarRepresentanteLegal, setMostrarRepresentanteLegal] =
    useState(true);
  const [headerImgSrc, setHeaderImgSrc] = useState(null);
  const [footerImgSrc, setFooterImgSrc] = useState(null);
  const [, setImgCarregadas] = useState(false);
  const anoProcesso = new Date().getFullYear();

  const carregarPdfLayout = useCallback(async (tipoLicencaId) => {
    if (!tipoLicencaId) {
      setHeaderImgSrc(licencaHeaderImg);
      setFooterImgSrc(licencaFooterImg);
      setImgCarregadas(true);
      return;
    }
    try {
      const res = await pdfLayoutService.obterPorTipoLicenca(tipoLicencaId);
      const layoutId = res.data?.data;
      if (!layoutId) {
        setHeaderImgSrc(licencaHeaderImg);
        setFooterImgSrc(licencaFooterImg);
        setImgCarregadas(true);
        return;
      }

      const toDataUrl = (blob) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });

      const [headerRes, footerRes] = await Promise.all([
        pdfLayoutService.getHeaderImage(layoutId).catch(() => null),
        pdfLayoutService.getFooterImage(layoutId).catch(() => null),
      ]);

      setHeaderImgSrc(headerRes ? await toDataUrl(headerRes.data) : licencaHeaderImg);
      setFooterImgSrc(footerRes ? await toDataUrl(footerRes.data) : licencaFooterImg);
    } catch {
      setHeaderImgSrc(licencaHeaderImg);
      setFooterImgSrc(licencaFooterImg);
    } finally {
      setImgCarregadas(true);
    }
  }, []);

  useEffect(() => {
    carregarDados();

    const user = authService.getCurrentUser();
    setUsuarioAtual(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, modoRegeneracao]);

  useEffect(() => {
    if (!solicitacao) return;

    if (!modoRegeneracao && solicitacao.observacoes) {
      setObservacoesEditadas(solicitacao.observacoes);
    }

    if (solicitacao?.tipoLicencaId) {
      carregarPdfLayout(solicitacao.tipoLicencaId);
    }
  }, [solicitacao, carregarPdfLayout, modoRegeneracao]);

  const carregarDados = async () => {
    try {
      setLoading(true);
      setError("");
      const data = await licencasService.obterSolicitacao(id);
      setSolicitacao(data);
      if (data.numeroDaLicenca) {
        setNumeroDaLicenca(data.numeroDaLicenca);
      }

      if (modoRegeneracao) {
        const respostaLicenca =
          await licencaEmitidaService.obterPorSolicitacaoDeLicencaId(id);
        const licenca = respostaLicenca?.data ?? respostaLicenca;
        setObservacoesEditadas(licenca?.observacoes ?? "");
        setCondicionantesGerais(licenca?.condicionantesGerais ?? "");
        setCondicionantesComPrazo(licenca?.condicionantesComPrazo ?? "");
        setCondicionantesEspecificas(licenca?.condicionantesEspecificas ?? "");
      }

      const possuiSnapshotRepresentado = Boolean(
        data.solicitadoPorRepresentado && data.representadoSnapshot,
      );

      if (data.createUserId && !possuiSnapshotRepresentado) {
        try {
          const usuarioData = await usuarioService.obterUsuarioPorId(
            data.createUserId,
          );
          setSolicitante(usuarioData);
        } catch (err) {}
      }

      if (data.empreendimentoId) {
        try {
          const empreendimentoData = await empreendimentoService.obterPorId(
            data.empreendimentoId,
          );

          setEmpreendimento(empreendimentoData);
        } catch (err) {
          console.error("Erro ao buscar dados do empreendimento:", err);
        }
      }
    } catch (err) {
      setError(
        modoRegeneracao
          ? getApiErrorMessage(err, "Erro ao carregar a licença para regeneração.")
          : "Erro ao carregar a solicitação",
      );
    } finally {
      setLoading(false);
    }
  };

  const gerarPdfBlob = async () => {
    return withFixedPdfCaptureWidth(previewRef.current, async () => {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = PDF_PAGE_WIDTH_MM;
      const pageHeight = PDF_PAGE_HEIGHT_MM;

      const headerCanvas = await html2canvasForPdf(
        html2canvas,
        headerRef.current,
      );
      const headerImg = canvasToJpegDataUrl(headerCanvas);
      const headerHeight = canvasHeightInMm(headerCanvas, pageWidth);

      const footerCanvas = await html2canvasForPdf(
        html2canvas,
        footerRef.current,
      );
      const footerImg = canvasToJpegDataUrl(footerCanvas);
      const footerHeight = canvasHeightInMm(footerCanvas, pageWidth);

      const contentCanvas = await html2canvasForPdf(
        html2canvas,
        contentRef.current,
      );
      const paging = getContentPaging(
        contentCanvas,
        headerHeight,
        footerHeight,
        pageWidth,
        pageHeight,
        { signatureBoxYTopMm: PDF_SIG_BOX_Y_TOP_MM },
      );

      for (let page = 0; page < paging.totalPages; page++) {
        if (page > 0) pdf.addPage();
        addSlicedContentImage(
          pdf,
          contentCanvas,
          page,
          paging,
          pageWidth,
          headerHeight,
        );
        pdf.addImage(headerImg, "JPEG", 0, 0, pageWidth, headerHeight);
        pdf.addImage(
          footerImg,
          "JPEG",
          0,
          pageHeight - footerHeight,
          pageWidth,
          footerHeight,
        );
      }

      const dataAtualFormatada = formatDateToShow(new Date().toISOString());
      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.2);
      pdf.setTextColor(0, 0, 0);

      pdf.setFillColor(255, 255, 255);
      pdf.rect(
        PDF_SIG_DATE_X_MM,
        PDF_SIG_BOX_Y_TOP_MM,
        PDF_SIG_DATE_W_MM,
        PDF_SIG_BOX_H_MM,
        "F",
      );
      pdf.rect(
        PDF_SIG_BOX_X_MM,
        PDF_SIG_BOX_Y_TOP_MM,
        PDF_SIG_BOX_W_MM,
        PDF_SIG_BOX_H_MM,
        "F",
      );

      pdf.rect(
        PDF_SIG_DATE_X_MM,
        PDF_SIG_BOX_Y_TOP_MM,
        PDF_SIG_DATE_W_MM,
        PDF_SIG_BOX_H_MM,
      );
      pdf.setFontSize(8);
      pdf.text(
        "Data",
        PDF_SIG_DATE_X_MM + PDF_SIG_DATE_W_MM / 2,
        PDF_SIG_BOX_Y_TOP_MM + 5,
        { align: "center" },
      );
      pdf.setFontSize(10);
      pdf.text(
        dataAtualFormatada,
        PDF_SIG_DATE_X_MM + PDF_SIG_DATE_W_MM / 2,
        PDF_SIG_BOX_Y_TOP_MM + PDF_SIG_BOX_H_MM / 2 + 3,
        { align: "center" },
      );

      pdf.rect(
        PDF_SIG_BOX_X_MM,
        PDF_SIG_BOX_Y_TOP_MM,
        PDF_SIG_BOX_W_MM,
        PDF_SIG_BOX_H_MM,
      );
      pdf.setFontSize(8);
      pdf.text(
        "Assinatura Digital:",
        PDF_SIG_BOX_X_MM + 2,
        PDF_SIG_BOX_Y_TOP_MM + PDF_SIG_LABEL_HEIGHT_MM - 1,
      );

      const nomeEmpreendimento = empreendimento?.nome || "Empreendimento";
      const dataAtual = new Date().toISOString().split("T")[0];
      const nomeArquivo = `Licenca-${nomeEmpreendimento.replace(/[^a-zA-Z0-9]/g, "_")}-${dataAtual}.pdf`;

      const pdfBlob = pdf.output("blob");
      return new File([pdfBlob], nomeArquivo, { type: "application/pdf" });
    });
  };

  const handleEmitirLicenca = async () => {
    try {
      setEmitindo(true);
      setError("");

      if (!solicitacao.numeroProcesso && !ehNumeroInformadoValido(numeroInformado)) {
        setError("Informe um número de processo válido (apenas dígitos).");
        return;
      }

      if (!solicitacao.numeroDaLicenca && !numeroDaLicenca.trim()) {
        setError("Informe o número da licença.");
        return;
      }

      const pdfFile = await gerarPdfBlob();

      const extras = {
        condicionantesGerais,
        condicionantesComPrazo,
        condicionantesEspecificas,
        observacoes: observacoesEditadas,
      };
      if (!solicitacao.numeroProcesso) {
        extras.NumeroInformado = numeroInformado.trim();
      }
      if (!solicitacao.numeroDaLicenca) {
        extras.NumeroDaLicenca = numeroDaLicenca.trim();
      }

      const resposta = await licencaEmitidaService.criarLicencaEmitida(
        id,
        pdfFile,
        null,
        null,
        extras,
      );

      setLicencaEmitida(resposta?.data || resposta);
      setSucessoEmissao(true);
    } catch (err) {
      setError(getApiErrorMessage(err, "Erro ao emitir a licença."));
    } finally {
      setEmitindo(false);
    }
  };

  const handleReemitirLicenca = async () => {
    try {
      setEmitindo(true);
      setError("");
      setConfirmacaoRegeneracaoAberta(false);

      if (!solicitacao.numeroProcesso) {
        setError("A regeneração exige que a solicitação já possua número de processo.");
        return;
      }

      if (!solicitacao.numeroDaLicenca && !numeroDaLicenca.trim()) {
        setError("Informe o número da licença.");
        return;
      }

      const pdfFile = await gerarPdfBlob();
      const extras = {
        condicionantesGerais,
        condicionantesComPrazo,
        condicionantesEspecificas,
        observacoes: observacoesEditadas,
      };
      if (!solicitacao.numeroDaLicenca) {
        extras.NumeroDaLicenca = numeroDaLicenca.trim();
      }
      const resposta = await licencaEmitidaService.regenerarLicencaEmitida(id, pdfFile, extras);

      setLicencaEmitida(resposta?.data || resposta);
      setSucessoEmissao(true);
    } catch (err) {
      setError(getApiErrorMessage(err, "Erro ao regenerar a licença."));
    } finally {
      setEmitindo(false);
    }
  };

  const getTipoLicencaLabel = (tipo) => {
    const tipoLabels = {
      PREVIA: "Licença Prévia",
      INSTALACAO: "Licença de Instalação",
      OPERACAO: "Licença de Operação",
      LAC: "Licença por Adesão e Compromisso",
      LAU: "Licença Ambiental Única",
    };
    return tipoLabels[tipo] || tipo;
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!solicitacao) {
    return (
      <Container>
        <Box sx={{ mt: 4 }}>
          <Alert severity="error">Solicitação não encontrada</Alert>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{ mt: 2 }}
          >
            Voltar
          </Button>
        </Box>
      </Container>
    );
  }

  const snapshotRepresentado = solicitacao.solicitadoPorRepresentado
    ? solicitacao.representadoSnapshot || null
    : null;
  const empreendedorEhPessoaJuridica = snapshotRepresentado
    ? isRepresentadoPessoaJuridica(snapshotRepresentado)
    : isPessoaJuridica(solicitante);
  const razaoSocialEmpreendedor = snapshotRepresentado
    ? obterRazaoSocialRepresentado(snapshotRepresentado)
    : obterRazaoSocialUsuario(solicitante);
  const rotuloNomeEmpreendedor = snapshotRepresentado
    ? obterRotuloNomeRepresentado(snapshotRepresentado)
    : obterRotuloNomeSolicitante(solicitante);
  const nomeEmpreendedor =
    (snapshotRepresentado
      ? obterNomeExibicaoRepresentado(snapshotRepresentado)
      : obterNomeExibicaoUsuario(solicitante)) ||
    solicitacao.solicitanteNome ||
    "";
  const documentoEmpreendedor = snapshotRepresentado
    ? snapshotRepresentado.cpf
    : solicitante?.cpf;
  const enderecoEmpreendedor = snapshotRepresentado
    ? montarEnderecoDoSnapshotRepresentado(snapshotRepresentado)
    : solicitante?.endereco;
  const enderecoEmpreendimentoFormatado = formatarEnderecoLicenca(
    empreendimento?.endereco,
  );

  const prefixoProcesso = solicitacao.codigoTipoLicenca || "";
  const numeroProcessoExibicao =
    solicitacao.numeroProcesso ||
    montarNumeroProcessoPreview(prefixoProcesso, numeroInformado, anoProcesso);
  const numeroDaLicencaExibicao =
    solicitacao.numeroDaLicenca || numeroDaLicenca.trim() || "—";
  const licencaJaPossuiNumero = Boolean(solicitacao.numeroDaLicenca);
  const processoValido =
    Boolean(solicitacao.numeroProcesso) || ehNumeroInformadoValido(numeroInformado);
  const numeroDaLicencaValido =
    licencaJaPossuiNumero || Boolean(numeroDaLicenca.trim());
  const podeEmitir = modoRegeneracao
    ? Boolean(solicitacao.numeroProcesso) && numeroDaLicencaValido
    : processoValido && numeroDaLicencaValido;
  const tituloPagina = modoRegeneracao ? "Regenerar Licença" : "Emitir Licença";
  const rotuloBotaoAcao = modoRegeneracao ? "Reemitir Licença" : "Emitir Licença";
  const mensagemSucessoTitulo = modoRegeneracao
    ? "Licença Regenerada com Sucesso!"
    : "Licença Emitida com Sucesso!";
  const mensagemSucessoCorpo = modoRegeneracao
    ? "O PDF foi substituído. A solicitação voltou para pendente de assinatura."
    : "Sua licença foi emitida.";
  const handleAcaoPrincipal = modoRegeneracao
    ? () => setConfirmacaoRegeneracaoAberta(true)
    : handleEmitirLicenca;

  return (
    <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      <Box sx={{ mt: 4, mb: 8 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ mb: 3 }}
        >
          Voltar
        </Button>

        {sucessoEmissao ? (
          <Paper
            elevation={0}
            sx={{
              p: 4,
              textAlign: "center",
              backgroundColor: "success.light",
              border: 2,
              borderColor: "success.main",
              borderRadius: 2,
              mb: 3,
            }}
          >
            <CheckCircleIcon
              sx={{
                fontSize: 80,
                color: "success.main",
                mb: 2,
              }}
            />
            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, mb: 1 }}>
              {mensagemSucessoTitulo}
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
              {mensagemSucessoCorpo}
            </Typography>

            {licencaEmitida?.documento_licenca && (
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ justifyContent: "center", alignItems: "stretch" }}
              >
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<FileDownloadIcon />}
                  href={licencaEmitida.documento_licenca}
                  target="_blank"
                  rel="noopener noreferrer"
                  fullWidth
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  Baixar Licença
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  fullWidth
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  Voltar
                </Button>
              </Stack>
            )}
          </Paper>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "stretch", md: "center" },
                gap: 2,
                mb: 4,
              }}
            >
              <Typography
                variant="h4"
                component="h1"
                sx={{ fontWeight: 600, fontSize: { xs: "1.1rem", md: "1.5rem" } }}
              >
                {tituloPagina}
              </Typography>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ alignItems: "stretch" }}
              >
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  disabled={emitindo}
                  fullWidth
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleAcaoPrincipal}
                  disabled={emitindo || !podeEmitir}
                  fullWidth
                  sx={{ minWidth: { sm: 200 }, width: { xs: "100%", sm: "auto" } }}
                >
                  {rotuloBotaoAcao}
                </Button>
              </Stack>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}

            <Alert severity="info" sx={{ mb: 3 }}>
              {modoRegeneracao
                ? "Revise os dados carregados da emissão anterior. Ao reemitir, o PDF atual será substituído e a licença voltará a aguardar assinatura do secretário."
                : "Ao emitir a licença, você confirma que todos os requisitos foram atendidos e a licença será considerada válida a partir de sua emissão."}
            </Alert>

            <Grid container spacing={3} sx={{ alignItems: "stretch" }}>
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 3, md: 4 },
                    borderRadius: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={6}>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ mb: 0.5 }}
                      >
                        Tipo de Licença
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {getTipoLicencaLabel(solicitacao.nomeTipoLicenca)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {solicitacao.numeroProcesso || modoRegeneracao ? (
                        <>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ mb: 0.5 }}
                          >
                            Número do Processo
                          </Typography>
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {solicitacao.numeroProcesso || "—"}
                          </Typography>
                        </>
                      ) : (
                        <NumeroProcessoField
                          prefixo={prefixoProcesso}
                          value={numeroInformado}
                          onChange={setNumeroInformado}
                          ano={anoProcesso}
                          error={Boolean(numeroInformado) && !ehNumeroInformadoValido(numeroInformado)}
                          helperText={
                            Boolean(numeroInformado) && !ehNumeroInformadoValido(numeroInformado)
                              ? "Informe apenas dígitos (1 a 10)."
                              : undefined
                          }
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {licencaJaPossuiNumero ? (
                        <>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ mb: 0.5 }}
                          >
                            Número da Licença
                          </Typography>
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {solicitacao.numeroDaLicenca}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ mb: 0.5 }}
                          >
                            Número da Licença
                          </Typography>
                          <TextField
                            fullWidth
                            value={numeroDaLicenca}
                            onChange={(e) => setNumeroDaLicenca(e.target.value)}
                            placeholder="Informe o número da licença"
                            variant="outlined"
                            required
                            inputProps={{ maxLength: NUMERO_DA_LICENCA_MAX }}
                            InputProps={{
                              endAdornment: (
                                <CharCounter
                                  value={numeroDaLicenca}
                                  maxLength={NUMERO_DA_LICENCA_MAX}
                                />
                              ),
                            }}
                          />
                        </>
                      )}
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 3 }} />

                  {/* Identificação do Empreendedor */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Identificação do Empreendedor
                    </Typography>
                    <Grid container spacing={2}>
                      {empreendedorEhPessoaJuridica && (
                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">
                            Razão Social
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {razaoSocialEmpreendedor || "Não informado"}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary">
                          {rotuloNomeEmpreendedor}
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {nomeEmpreendedor || "Não informado"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          CPF/CNPJ
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {documentoEmpreendedor
                            ? formatCpfCnpj(String(documentoEmpreendedor))
                            : "Não informado"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          CEP
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {enderecoEmpreendedor?.cep
                            ? formatCEP(enderecoEmpreendedor.cep)
                            : "Não informado"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          Endereço
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {enderecoEmpreendedor?.rua || "Não informado"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          Município
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {enderecoEmpreendedor?.municipio || "Não informado"}
                        </Typography>
                      </Grid>
                      {empreendedorEhPessoaJuridica && (
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={mostrarRepresentanteLegal}
                                onChange={(event) =>
                                  setMostrarRepresentanteLegal(
                                    event.target.checked,
                                  )
                                }
                                inputProps={{
                                  "aria-label":
                                    "Exibir representante legal na licença",
                                }}
                              />
                            }
                            label="Exibir representante legal na licença"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Box>

                  <Divider sx={{ my: 3 }} />

                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Identificação do Empreendimento
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          Nome
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {empreendimento?.nome || "Não informado"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          CNPJ
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {empreendimento?.cnpj || "Não informado"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          Endereço
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {enderecoEmpreendimentoFormatado || "Não informado"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">
                          Área
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {empreendimento?.area
                            ? `${empreendimento.area} ${UNIDADE_MEDIDA_AREA_OPTIONS.find((o) => o.value === (empreendimento.unidadeMedidaArea ?? 0))?.label ?? "ha"}`
                            : "Não informado"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  <Divider sx={{ my: 3 }} />

                  {/* Observações */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Observações
                    </Typography>
                    <TextField
                      multiline
                      rows={6}
                      fullWidth
                      value={observacoesEditadas}
                      onChange={(e) => setObservacoesEditadas(e.target.value)}
                      placeholder="Adicione observações sobre a solicitação..."
                      variant="outlined"
                      inputProps={{ maxLength: 3000 }}
                      sx={{ mb: 2 }}
                    />
                  </Box>

                  <Divider sx={{ my: 3 }} />

                  {/* Condicionantes Gerais */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Condicionantes Gerais
                    </Typography>
                    <TextField
                      multiline
                      rows={6}
                      fullWidth
                      value={condicionantesGerais}
                      onChange={(e) => setCondicionantesGerais(e.target.value)}
                      placeholder="Adicione condicionantes gerais..."
                      variant="outlined"
                      inputProps={{ maxLength: 4000 }}
                      sx={{ mb: 2 }}
                    />
                  </Box>

                  <Divider sx={{ my: 3 }} />

                  {/* Condicionantes com Prazo */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Condicionantes com Prazo
                    </Typography>
                    <TextField
                      multiline
                      rows={6}
                      fullWidth
                      value={condicionantesComPrazo}
                      onChange={(e) => setCondicionantesComPrazo(e.target.value)}
                      placeholder="Adicione condicionantes com prazo..."
                      variant="outlined"
                      inputProps={{ maxLength: 4000 }}
                      sx={{ mb: 2 }}
                    />
                  </Box>

                  <Divider sx={{ my: 3 }} />

                  {/* Condicionantes Específicas */}
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                      Condicionantes Específicas
                    </Typography>
                    <TextField
                      multiline
                      rows={6}
                      fullWidth
                      value={condicionantesEspecificas}
                      onChange={(e) => setCondicionantesEspecificas(e.target.value)}
                      placeholder="Adicione condicionantes específicas..."
                      variant="outlined"
                      inputProps={{ maxLength: 4000 }}
                      sx={{ mb: 2 }}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "flex-start", sm: "center" },
                        gap: 1,
                        mt: 2,
                      }}
                    >
                      <Box>
                        <Typography variant="body2" color="textSecondary">
                          Data da licença:{" "}
                          {formatDateToShow(new Date().toISOString())}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Validade:{" "}
                          {formatarDataValidadeLicenca(solicitacao.dataValidade) ||
                            "Não informada"}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="textSecondary">
                        Analista: {usuarioAtual?.username || "Não informado"}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>

              {/* Coluna Direita - Visualizador PDF */}
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 2, sm: 3 },
                    borderRadius: 2,
                    backgroundColor: "background.default",
                    border: 1,
                    borderColor: "divider",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      textAlign: "center",
                      mb: 3,
                      fontWeight: 600,
                      color: "text.secondary",
                      fontSize: "12px",
                    }}
                  >
                    PRÉVIA DO DOCUMENTO
                  </Typography>

                  <Box
                    sx={{
                      overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: { xs: 400, md: 600 },
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      flex: 1,
                    }}
                  >
                  <Box
                    ref={previewRef}
                    sx={{
                      width: "100%",
                      maxWidth: `${PDF_DOCUMENT_WIDTH_PX}px`,
                      minWidth: { xs: 320, sm: "auto" },
                      display: "flex",
                      flexDirection: "column",
                      gap: 0,
                      mx: "auto",
                    }}
                  >
                    {/* CABEÇALHO COM IMAGEM */}
                    <Box
                      ref={headerRef}
                      sx={{
                        backgroundColor: "white",
                        overflow: "hidden",
                        borderRadius: "4px 4px 0 0",
                        height: 80,
                      }}
                    >
                      {headerImgSrc && (
                        <img
                          src={headerImgSrc}
                          alt="Cabeçalho da licença"
                          style={{
                            width: "100%",
                            height: "80px",
                            objectFit: "fill",
                            display: "block",
                          }}
                        />
                      )}
                    </Box>

                    {/* CONTEÚDO DA PRÉVIA DO DOCUMENTO */}
                    <ThemeProvider theme={temaDocumentoLicenca}>
                    <Box
                      ref={contentRef}
                      data-testid="conteudo-documento-licenca"
                      sx={estilosDocumentoLicenca}
                    >
                      <Box
                        sx={{
                          border: "1px solid #000",
                          p: 1.5,
                          mb: 2,
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "black",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                            mb: 1.5,
                          }}
                        >
                          {getTipoLicencaLabel(solicitacao.nomeTipoLicenca)}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: 1,
                          }}
                        >
                          <Box sx={{ flex: 1, textAlign: "center" }}>
                            <Typography
                              sx={{ fontSize: "10px", fontWeight: "bold" }}
                            >
                              Número da Licença
                            </Typography>
                            <Typography
                              sx={{ fontSize: "11px", fontWeight: "bold", mt: 0.5 }}
                            >
                              {numeroDaLicencaExibicao}
                            </Typography>
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: "bold",
                              pt: 0.75,
                              flexShrink: 0,
                            }}
                            aria-hidden="true"
                          >
                            -
                          </Typography>
                          <Box sx={{ flex: 1, textAlign: "center" }}>
                            <Typography
                              sx={{ fontSize: "10px", fontWeight: "bold" }}
                            >
                              Número do Processo
                            </Typography>
                            <Typography
                              sx={{ fontSize: "11px", fontWeight: "bold", mt: 0.5 }}
                            >
                              {numeroProcessoExibicao || "—"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Box
                          sx={{
                            border: "1px solid #000",
                            p: 1.5,
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            alignItems: { xs: "flex-start", sm: "center" },
                            gap: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "11px",
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>Validade da licença:</strong>{" "}
                            {formatarDataValidadeLicenca(solicitacao.dataValidade) ||
                              "Não informada"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "10px",
                            }}
                          >
                            Esta licença permanece vigente até a data indicada.
                          </Typography>
                        </Box>
                      </Box>

                      {/* Identificação do Empreendedor */}
                      <Box sx={{ mb: 2 }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "11px",
                            mb: 0.5,
                          }}
                        >
                          Identificação do Empreendedor
                        </Typography>
                        <Box sx={{ border: "1px solid #000", p: 1.5 }}>
                          {empreendedorEhPessoaJuridica && (
                            <Typography
                              sx={{
                                fontSize: "11px",
                                mb: 0.5,
                                "& strong": { fontSize: "10px" },
                              }}
                            >
                              <strong>Razão Social:</strong>{" "}
                              {razaoSocialEmpreendedor ||
                                "____________________"}
                            </Typography>
                          )}
                          {(!empreendedorEhPessoaJuridica ||
                            mostrarRepresentanteLegal) && (
                            <Typography
                              sx={{
                                fontSize: "11px",
                                mb: 0.5,
                                "& strong": { fontSize: "10px" },
                              }}
                            >
                              <strong>{rotuloNomeEmpreendedor}:</strong>{" "}
                              {nomeEmpreendedor || "____________________"}
                            </Typography>
                          )}
                          <Typography
                            sx={{
                              fontSize: "11px",
                              mb: 0.5,
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>CPF/CNPJ:</strong>{" "}
                            {documentoEmpreendedor
                              ? formatCpfCnpj(String(documentoEmpreendedor))
                              : "____________________"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              mb: 0.5,
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>Endereço:</strong>{" "}
                            {enderecoEmpreendedor?.rua ||
                              "____________________"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              mb: 0.5,
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>Município:</strong>{" "}
                            {enderecoEmpreendedor?.municipio ||
                              "____________________"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>CEP:</strong>{" "}
                            {enderecoEmpreendedor?.cep
                              ? formatCEP(enderecoEmpreendedor.cep)
                              : "____________________"}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Identificação do Empreendimento */}
                      <Box sx={{ mb: 2 }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "11px",
                            mb: 0.5,
                          }}
                        >
                          Identificação do Empreendimento
                        </Typography>
                        <Box sx={{ border: "1px solid #000", p: 1.5 }}>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              mb: 0.5,
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>Nome:</strong>{" "}
                            {empreendimento?.nome || "____________________"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              mb: 0.5,
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>CNPJ:</strong>{" "}
                            {empreendimento?.cnpj || "____________________"}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "11px",
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>Endereço:</strong>{" "}
                            {enderecoEmpreendimentoFormatado ||
                              "____________________"}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "11px",
                              "& strong": { fontSize: "10px" },
                            }}
                          >
                            <strong>Área:</strong>{" "}
                            {empreendimento?.area
                              ? `${empreendimento.area} ${UNIDADE_MEDIDA_AREA_OPTIONS.find((o) => o.value === (empreendimento.unidadeMedidaArea ?? 0))?.label ?? "ha"}`
                              : "____________________"}
                          </Typography>
                        </Box>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <Box
                          sx={{
                            border: "1px solid #000",
                            p: 1.5,
                            minHeight: "40px",
                            mb: 1,
                          }}
                        >
                          <Typography
                            sx={{ fontSize: "11px", whiteSpace: "pre-wrap" }}
                          >
                            {observacoesEditadas ||
                              "Nenhuma observação informada."}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Condicionantes Gerais */}
                      <Box sx={{ mb: 2 }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "11px",
                            mb: 0.5,
                          }}
                        >
                          Condicionantes Gerais
                        </Typography>
                        <Box
                          sx={{
                            border: "1px solid #000",
                            p: 1.5,
                            minHeight: "40px",
                            mb: 1,
                          }}
                        >
                          <Typography
                            sx={{ fontSize: "11px", whiteSpace: "pre-wrap" }}
                          >
                            {condicionantesGerais ||
                              "Nenhuma condicionante geral informada."}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Condicionantes com Prazo */}
                      <Box sx={{ mb: 2 }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "11px",
                            mb: 0.5,
                          }}
                        >
                          Condicionantes com Prazo
                        </Typography>
                        <Box
                          sx={{
                            border: "1px solid #000",
                            p: 1.5,
                            minHeight: "40px",
                            mb: 1,
                          }}
                        >
                          <Typography
                            sx={{ fontSize: "11px", whiteSpace: "pre-wrap" }}
                          >
                            {condicionantesComPrazo ||
                              "Nenhuma condicionante com prazo informada."}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Condicionantes Específicas */}
                      <Box sx={{ mb: 2 }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "11px",
                            mb: 0.5,
                          }}
                        >
                          Condicionantes Específicas
                        </Typography>
                        <Box
                          sx={{
                            border: "1px solid #000",
                            p: 1.5,
                            minHeight: "40px",
                            mb: 1,
                          }}
                        >
                          <Typography
                            sx={{ fontSize: "11px", whiteSpace: "pre-wrap" }}
                          >
                            {condicionantesEspecificas ||
                              "Nenhuma condicionante específica informada."}
                          </Typography>
                        </Box>
                      </Box>

                      <Box sx={{ mb: 2 }}>
                        {/* Texto padrão */}
                        <Box
                          sx={{
                            border: "1px solid #000",
                            p: 1.5,
                            minHeight: "30px",
                            mb: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <Typography sx={{ fontSize: "10px", flex: 1 }}>
                            O presente documento foi emitido sem rasura e/ou
                            colagem.
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <QRCodeSVG
                              value={`${window.location.origin}/validar/licenca/${id}`}
                              size={70}
                              level="M"
                            />
                            <Typography
                              sx={{ fontSize: "8px", mt: 0.5, textAlign: "center" }}
                            >
                              Escaneie para validar
                            </Typography>
                          </Box>
                        </Box>

                      </Box>
                    </Box>
                    </ThemeProvider>

                    {/* RODAPÉ COM IMAGEM */}
                    <Box
                      ref={footerRef}
                      sx={{
                        backgroundColor: "white",
                        borderTop: "none",
                        overflow: "hidden",
                        borderRadius: "0 0 4px 4px",
                        height: 60,
                      }}
                    >
                      {footerImgSrc && (
                        <img
                          src={footerImgSrc}
                          alt="Rodapé da licença"
                          style={{
                            width: "100%",
                            height: "60px",
                            objectFit: "fill",
                            display: "block",
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </>
        )}
      </Box>

      <Dialog
        open={confirmacaoRegeneracaoAberta}
        onClose={() => !emitindo && setConfirmacaoRegeneracaoAberta(false)}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon color="warning" />
          Regenerar licença
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente regenerar esta licença? O PDF existente será{" "}
            <strong>substituído</strong> e a assinatura digital anterior deixará
            de valer. O secretário precisará assinar novamente.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmacaoRegeneracaoAberta(false)}
            disabled={emitindo}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="warning"
            disabled={emitindo}
            startIcon={
              emitindo ? <CircularProgress size={20} color="inherit" /> : null
            }
            onClick={handleReemitirLicenca}
          >
            Sim, reemitir
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default EmitirLicenca;
